import React, {useCallback, useEffect, useState} from "react";
import api from 'service/api';
import {useToggle} from "react-use";
import AppApi from "settings/app-api";
import {normalize} from "shared/utils";
import {isSuccessResponse} from "shared/validators";

export const useQuestions = () => {
    const originalItems = React.createRef([]);
    const [items, setItems] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useToggle(false);
    const [isFilterActive, setFilterActive] = useToggle(false);

    const clearFilter = useCallback(() => {
        setSearch('');
        setFilterActive(false);
        setItems(originalItems.current ?? []);
    }, []);

    const onFilter = useCallback((search) => {
        setSearch(search);
        setFilterActive(true);
        setItems(
            originalItems.current?.filter(item => {
                const question = normalize(item.question);
                const answer = normalize(item.answer);
                const text = normalize(search);
                return question.includes(text) || answer.includes(text)
            }) ?? []
        )
    }, []);

    const loadQuestions = useCallback(async () => {
        try {
            setLoading(true);

            const response = await api.get(AppApi.faq);

            if (isSuccessResponse(response)) {
                originalItems.current = response.data.data.faq || [];
                setItems(originalItems.current)
            }
        } finally {
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        loadQuestions();
    }, []);

    return {items, onFilter, loading, isFilterActive, clearFilter, search}
}
